export const getRequestValue = (key) => {
    if (typeof window === 'undefined') return null;
  
    const params = new URLSearchParams(window.location.search);
    return params.get(key);
  };
  